"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ShadowBoxCTA = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _theming = require("@storybook/theming");

var _styles = require("./shared/styles");

var _excluded = ["action", "headingText", "messageText"];
var ShadowBox = (0, _theming.styled)("div", process.env.NODE_ENV === "production" ? {
  target: "eaeuy365"
} : {
  target: "eaeuy365",
  label: "ShadowBox"
})("background:#ffffff;box-shadow:0 1px 3px 0 rgba(0, 0, 0, 0.1),0 5px 15px 0 rgba(0, 0, 0, 0.05);border-radius:", _styles.spacing.borderRadius.small, "px;");
var ShadowBoxCTAWrapper = ( /*#__PURE__*/0, _theming.styled)(ShadowBox, process.env.NODE_ENV === "production" ? {
  target: "eaeuy364"
} : {
  target: "eaeuy364",
  label: "ShadowBoxCTAWrapper"
})("padding:", _styles.spacing.padding.large, "px;display:flex;flex-wrap:wrap;align-items:center;text-align:center;@media (min-width: ", _styles.breakpoint, "px){text-align:left;}");
var TextWrapper = (0, _theming.styled)("div", process.env.NODE_ENV === "production" ? {
  target: "eaeuy363"
} : {
  target: "eaeuy363",
  label: "TextWrapper"
})("line-height:20px;flex:0 1 100%;@media (min-width: ", _styles.breakpoint, "px){flex:1;}");
var HeadingText = (0, _theming.styled)("div", process.env.NODE_ENV === "production" ? {
  target: "eaeuy362"
} : {
  target: "eaeuy362",
  label: "HeadingText"
})("font-size:", _styles.typography.size.s3, "px;font-weight:", _styles.typography.weight.black, ";");
var MessageText = (0, _theming.styled)("div", process.env.NODE_ENV === "production" ? {
  target: "eaeuy361"
} : {
  target: "eaeuy361",
  label: "MessageText"
})("font-size:", _styles.typography.size.s2, "px;margin-top:4px;");
var Action = (0, _theming.styled)("div", process.env.NODE_ENV === "production" ? {
  target: "eaeuy360"
} : {
  target: "eaeuy360",
  label: "Action"
})("flex:0 0 100%;margin-top:1.5rem;button{padding:13px 28px;}@media (min-width: ", _styles.breakpoint, "px){flex:0 0 auto;margin-top:0;padding-left:60px;}");

var ShadowBoxCTA = function ShadowBoxCTA(_ref) {
  var action = _ref.action,
      headingText = _ref.headingText,
      messageText = _ref.messageText,
      rest = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement(ShadowBoxCTAWrapper, rest, /*#__PURE__*/_react["default"].createElement(TextWrapper, null, /*#__PURE__*/_react["default"].createElement(HeadingText, null, headingText), messageText && /*#__PURE__*/_react["default"].createElement(MessageText, null, messageText)), /*#__PURE__*/_react["default"].createElement(Action, null, action));
};

exports.ShadowBoxCTA = ShadowBoxCTA;